<app-header-list titulo="Lista de Locais" />

<ion-content [fullscreen]="true">
  <p-treeTable #tt [value]="nos" [scrollable]="true" [tableStyle]="{'min-width':'50rem'}"
               [paginator]="true" [rows]="100" [lazy]="true" (onLazyLoad)="load($event)"
               currentPageReportTemplate="{first}-{last}/{totalRecords}" [showCurrentPageReport]="true"
               [totalRecords]="total"
               filterMode="lenient"
               dataKey="id">
    <ng-template pTemplate="header">
      <tr>
        <th [ttSortableColumn]="'nome'">Nome
          <p-treeTableSortIcon [field]="'nome'"></p-treeTableSortIcon></th>
        <th>Biomas</th>
        <th [ttSortableColumn]="'tipo'">Tipo
          <p-treeTableSortIcon [field]="'tipo'"></p-treeTableSortIcon></th>
      </tr>
      <tr>
        <th>
<!--          <input pInputText type="text" (input)="tt.filter($event.target?.value, 'nome', 'startsWith')">-->
        </th>
        <th>
<!--          <input pInputText type="text" (input)="tt.filter($event.target?.value, 'biomas', 'contains')">-->
        </th>
        <th>
<!--          <input pInputText type="text" (input)="tt.filter($event.target?.value, 'tipo', 'startsWith')">-->
        </th>
      </tr>

    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
        <td>
          <p-treeTableToggler  [rowNode]="rowNode"></p-treeTableToggler>
          <ion-button  *ngIf="rowData?.new" routerLink="new/{{rowData?.id}}" color="success">
            <ion-icon  name="add"></ion-icon>
          </ion-button>
          <a routerLink="edit/{{rowData?.id}}">{{ rowData?.nome }}</a>

        </td>
        <td>
                    <span
                      *ngFor="let bioma of rowData?.biomas; let isLast=last"> {{ bioma?.nome }}{{isLast ? '' : ', '}}</span>
        </td>
        <td>{{ rowData?.tipo }}</td>
      </tr>
    </ng-template>
  </p-treeTable>
    <ion-fab slot="fixed"  vertical="bottom" horizontal="end">
      <ion-fab-button routerLink="new" color="success">
        <ion-icon  name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
</ion-content>

<app-rodape [exibirBotoes]="false"/>
